// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607231203/js/" + chunkId + "." + {"44":"7ee1289f","225":"735fed8b","481":"bf78ef00","486":"f778305f","770":"9f37c10e"}[chunkId] + ".0.3366165783122481.chunk.js";
};